import { Component, OnInit } from "@angular/core";
import { ProcessService } from "../../../services/process.service";
import { ActivatedRoute, ParamMap, Router } from "@angular/router";
import { Process } from "../../../entities/process";
import { switchMap } from "rxjs/operators";
import { ReportService } from "src/app/services/report.service";
import { NgxSpinnerService } from "ngx-spinner";
import { saveAs } from "file-saver";
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";
import { sanitizeReportHtml } from "src/app/util/sanitize-report-html";
export interface DialogData {
  name: string;
}
@Component({
  selector: "app-process-view",
  templateUrl: "./process-view.component.html",
  styleUrls: ["./process-view.component.css"],
})
export class ProcessViewComponent implements OnInit {
  hasMapping = false;
  currentProcessId: number;
  // stages coming from the process structure
  stages = [];
  process: Process;
  missingStages = [];

  fileName: string;
  fileNamePDF: string;
  excelType: any;
  downloadType
  currentYear = new Date().getFullYear().toString();

  constructor(
    public processService: ProcessService,
    public reportService: ReportService,
    private router: Router,
    private route: ActivatedRoute,
    private spinner: NgxSpinnerService
  ) {}

  ngOnInit() {
    this.process = new Process();
    this.route.paramMap
      .pipe(
        switchMap((params: ParamMap) => {
          return this.processService.getProcess(params.get("id"));
        })
      )
      .subscribe(
        (process) => {
          this.processService
            .getProcessMapping(process["key"])
            .subscribe((result) => {
              this.hasMapping = result !== null;
              this.populatePages(process);
            });
        },
        (err) => {
          console.log(err);
        }
      );
  }

  populatePages(process) {
    this.process = process;
    this.currentProcessId = this.process.id;
    this.reportService.getPages(process["key"]).subscribe(
      (data) => {
        this.stages = data?.stages || [];
      },
      (err) => {
        console.log(err);
      }
    );
  }
  async downloadAvisFile() {
    let avisData = await this.processService.getAvisData(this.process.id).toPromise()
    const container = document.createElement("div");
    container.style.position = "absolute";
    container.style.left = "-9999px";
    container.style.width = "1980px"; 
    container.innerHTML = sanitizeReportHtml(avisData);
    document.body.appendChild(container);

    try {
        const canvas = await html2canvas(container, {
            allowTaint: true,
            useCORS: true,
            scale: 1,
            logging: false
        });

        document.body.removeChild(container);
        const imgData = canvas.toDataURL("image/jpeg", 0.7);
        const pdf = new jsPDF();
        const imgWidth = 190;
        const imgHeight = (canvas.height * imgWidth) / canvas.width;

        pdf.addImage(imgData, "JPEG", 10, 10, imgWidth, imgHeight);
        pdf.save("avis-" + this.process['tin'] + "-content.pdf");
        
    } catch (error) {
        console.error("Error generating PDF:", error);
        if (document.body.contains(container)) {
            document.body.removeChild(container);
        }
    }
}
  async downloadDeclarationTemplate() {
    try {
      let templateData = await this.processService.getDeclarationTemplateData(this.process.id).toPromise();
      const container = document.createElement("div");
      container.style.position = "absolute";
      container.style.left = "-9999px";
      container.style.width = "1980px";
      container.innerHTML = sanitizeReportHtml(templateData);
      document.body.appendChild(container);

      const canvas = await html2canvas(container, { allowTaint: true, useCORS: true, scale: 1, logging: false });
      document.body.removeChild(container);

      const imgData = canvas.toDataURL("image/jpeg", 0.7);
      const pdf = new jsPDF();
      const imgWidth = 190;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;
      pdf.addImage(imgData, "JPEG", 10, 10, imgWidth, imgHeight);
      pdf.save((this.process['declarationTemplateName'] || 'declaration-template') + '-' + this.process['tin'] + '.pdf');
    } catch (error) {
      console.error("Error generating declaration template PDF:", error);
    }
  }

  async downloadGeneratedFile(){
    this.downloadType = 'receiptData';
  
    try {
      let receiptData = await this.processService.downloadGeneratedFile(this.process.id).toPromise();
  
      const container = document.createElement("div");
      container.style.position = "absolute";
      container.style.left = "-9999px";
      container.style.width = "100%";
      container.innerHTML = sanitizeReportHtml(receiptData);
      document.body.appendChild(container);
  
      await html2canvas(container, { allowTaint: true, useCORS: true })
        .then((canvas) => {
          document.body.removeChild(container);
  
          const imgData = canvas.toDataURL("image/jpeg", 0.7);
          const pdf = new jsPDF();
          const imgWidth = 190;
          const imgHeight = (canvas.height * imgWidth) / canvas.width;
  
          pdf.addImage(imgData, "JPEG", 10, 10, imgWidth, imgHeight);
          pdf.save("submission-" + this.process['tin'] + "-content.pdf");
        });
    } catch (error) {
      console.error("Error generating PDF:", error);
    }
    }

  list() {
    this.router.navigate(["home"]);
  }

  downloadPdf(name) {
    this.spinner.show();
    this.processService.downloadPDF(name, this.process.id).subscribe((data) => {
      this.spinner.hide();
      const blob = data;
      const file = new Blob([blob], {});
      const filename = "document-" + Date.now() + ".pdf";
      saveAs(file, filename);
    });
  }

  downloadExcel(name) {
    this.spinner.show();
    this.processService
      .downloadExcel(name, this.process.id, this.process.year)
      .subscribe((data) => {
        this.spinner.hide();
        const blob = data;
        const file = new Blob([blob], {});
        const filename = "document_" + Date.now() + ".xlsx";
        saveAs(file, filename);
      });
  }

  downloadFileFromDocFlow(name, ext) {
    this.spinner.show();
    this.processService.downloadFileFromDocflow(name).subscribe((data) => {
      this.spinner.hide();
      const blob = data;
      const file = new Blob([blob], {});
      const filename = "document-" + Date.now() + "." + ext;
      saveAs(file, filename);
    });
  }

  getColorByStatus(stageKey) {
    var stageInQuestion = this.process["stages"].find(
      (element) => element.key === stageKey
    );
    if (stageInQuestion === undefined) {
      return "#e3e8e5";
    } else {
      if (stageInQuestion.status === "processing") {
        return "#757ce8"; //violet
      }
      return "#18a028";
    }
  }

  getTextColorByStatus(stageKey) {
    var stageInQuestion = this.process["stages"].find(
      (element) => element.key === stageKey
    );
    if (stageInQuestion === undefined) {
      return "#000501";
    } else {
      return "#f7fbf8";
    }
  }
}
